<template>
<div>
  <NavBar />
  <div class="row p-5">
    <h1>Under konstruktion!</h1>
    <div class="col-md-12">
      <TargetList />
    </div>
  </div>
</div>
</template>

<script>
import TargetList from "@/components/TargetList.vue";
import NavBar from "@/components/NavBar.vue";

export default {
  name: "Target",
  components: { TargetList, NavBar },
  setup() {},
};
</script>
